import { compose } from "redux";
import { connect } from "react-redux";
import React, { PureComponent } from "react";

import {
  employeeWorkScheduleFormOnChange,
  editEmployeeWorkScheduleOnSubmit,
} from "features/planner/employee/employee.actions";

import {
  WORK_SCHEDULE_FORM,
  EDIT_WORK_SCHEDULE_MODAL_ID,
} from "features/planner/employee/employee.constants";

import SimpleFormModal from "app/components/SimpleFormModal";
import WorkScheduleForm from "features/planner/employee/schedule/components/WorkScheduleForm";

class EditWorkScheduleModal extends PureComponent {
  render() {
    const {
      dispatchEmployeeWorkScheduleFormOnChange,
      dispatchCreateEmployeeWorkScheduleOnSubmit,
    } = this.props;

    return (
      <SimpleFormModal
        Icon={null}
        submitText="Save"
        title="Edit Work Schedule"
        component={WorkScheduleForm}
        modalId={EDIT_WORK_SCHEDULE_MODAL_ID}
        onSubmit={dispatchCreateEmployeeWorkScheduleOnSubmit}
        form={{
          form: WORK_SCHEDULE_FORM.ID,
          onChange: dispatchEmployeeWorkScheduleFormOnChange,
        }}
      />
    );
  }
}

export default compose(
  connect(
    null,
    {
      dispatchEmployeeWorkScheduleFormOnChange: employeeWorkScheduleFormOnChange,
      dispatchCreateEmployeeWorkScheduleOnSubmit: editEmployeeWorkScheduleOnSubmit,
    },
  ),
)(EditWorkScheduleModal);
